<template>
  <v-container fluid class="ma-0 pa-0">
    <AdminBreadCrumb title="配信先ブラックリスト一覧" />
    <EditInventoryListTargeting :list="list" :loading="loading" class="wrap" />
  </v-container>
</template>

<script>
import AdminBreadCrumb from '../../components/Shared/BreadCrumb/AdminBreadCrumb.vue'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import EditInventoryListTargeting from '@/components/Admin/InventoryListTargeting/InventoryListTargeting'

export default {
  name: 'InventoryListTargeting',
  components: { EditInventoryListTargeting, AdminBreadCrumb },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    list() {
      return this.$store.getters['inventoryListTargeting/list']
    },
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch('inventoryListTargeting/GET_LIST_FOR_OEM', {})
      this.loading = false
    },
  },
}
</script>

<style scoped>
.wrap {
  width: 100%;
}
</style>
